<template>
  <div style="width:500px;height:400px;">
    <live-player
      ref="p1"
      :bind-callback="handleBind"
      :pause-callback="handlePause"
      :play-callback="handlePlay"
      :distroy-callback="handleDistroy"
    ></live-player>
  </div>
</template>
<script>
import livePlayer from "@/components/livePlayer";
export default {
  components: { livePlayer },
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$refs["p1"].bind(
        "http://172.18.0.15:28866/013800138000-1/live.m3u8",
        { sim: "013800138000", ch: "1" }
      );
    },
    handleBind(params) {
      console.log("bind params is " + params.sim);
    },
    handlePause(params) {
      console.log("pause params is " + params.sim);
    },
    handlePlay(params) {
      console.log("play params is " + params.sim);
    },
    handleDistroy(params) {
      console.log("distroy params is " + params.sim);
    }
  }
};
</script>

<style>
</style>